<i
  *ngIf="!isEva"
  class="{{ dataIcon }}"
  [ngStyle]="styleIcon"
  [ngClass]="spinner == true ? 'pi-spin ' : ''"
></i>

<nb-icon
  *ngIf="isEva"
  icon="{{ dataIcon }}"
  [ngStyle]="styleIcon"
  [ngClass]="spinner == true ? 'pi-spin ' : ''"
></nb-icon>
